module.exports = __webpack_public_path__ + "static/media/blank_white_tshirt.69dcaf8b.png";